import { jsxs as l, jsx as t } from "react/jsx-runtime";
import { Paperclip as L, FileArchive as z, File as S, X as G, FileText as b, FileDown as V, SquareArrowOutUpRight as A, Info as B, Trash2 as M, CloudUpload as Z } from "lucide-react";
import { isZipMime as P, isAcceptedUploadMime as D, maxBytesFor as C } from "@virtual-care/media-isomorphic";
import { Label as U, Button as y, Dialog as q, DialogContent as O, DialogHeader as J, DialogTitle as _, Badge as H, DialogFooter as K, cn as X } from "@virtual-care/shadcn";
import { FieldMessage as Q, TheButton as F } from "@virtual-care/ui";
import { useState as h, useCallback as w } from "react";
import { useTranslation as j } from "react-i18next";
import { toast as k } from "sonner";
import { client as v } from "@virtual-care/hooks";
import { z as W } from "zod";
import { useDropzone as Y } from "react-dropzone";
function N(e) {
  return `${e.name}-${e.size}-${e.lastModified}`;
}
function ve() {
  const [e, n] = h({}), o = w(
    (s) => (a, i) => n((c) => ({
      ...c,
      [N(s)]: { uploaded: a, total: i }
    })),
    []
  ), r = w(() => n({}), []);
  return { progress: e, track: o, reset: r };
}
function xe({ field: e, progress: n }) {
  const o = (s, a) => {
    if (s) {
      const i = [...a.state.value || [], ...Array.from(s)];
      a.handleChange(i);
    }
  }, r = (s, a) => {
    const i = (a.state.value || []).filter(
      (c, d) => d !== s
    );
    a.handleChange(i);
  };
  return /* @__PURE__ */ l("div", { className: "space-y-4", children: [
    /* @__PURE__ */ t(U, { children: "إرفاق ملفات (اختياري)" }),
    /* @__PURE__ */ l("div", { className: "space-y-2", children: [
      /* @__PURE__ */ l(
        "label",
        {
          htmlFor: "file-upload",
          className: "flex w-full cursor-pointer items-center rounded-lg border bg-gray-50 p-3",
          children: [
            /* @__PURE__ */ t(L, { className: "ml-3 h-5 w-5 text-gray-400" }),
            /* @__PURE__ */ t("span", { className: "text-gray-500", children: "تحميل ملف" })
          ]
        }
      ),
      /* @__PURE__ */ t(
        "input",
        {
          type: "file",
          multiple: !0,
          accept: ".pdf,.png,.jpg,.jpeg,.zip",
          onChange: (s) => o(s.target.files, e),
          className: "hidden",
          id: "file-upload"
        }
      ),
      /* @__PURE__ */ t("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ l("div", { className: "text-xs text-gray-500", children: [
        /* @__PURE__ */ t("p", { children: "الصيغ: PDF, PNG, JPG, ZIP" }),
        /* @__PURE__ */ t("p", { children: "الحجم الأقصى: ١٠ ميجابايت (٢ جيجابايت لملفات ZIP)" })
      ] }) })
    ] }),
    e.state.value && e.state.value.length > 0 && /* @__PURE__ */ t("div", { className: "space-y-2", children: e.state.value.map((s, a) => {
      const i = P(s.type) ? z : S, c = n?.[N(s)], d = c ? c.uploaded / c.total : null;
      return /* @__PURE__ */ l(
        "div",
        {
          className: "space-y-1 rounded-lg border bg-gray-50/50 p-2 text-sm",
          children: [
            /* @__PURE__ */ l("div", { className: "flex items-center justify-between", children: [
              /* @__PURE__ */ l("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ t(i, { className: "h-5 w-5 text-gray-400" }),
                /* @__PURE__ */ t("span", { className: "truncate text-gray-700", children: s.name })
              ] }),
              /* @__PURE__ */ t(
                y,
                {
                  type: "button",
                  variant: "ghost",
                  size: "icon",
                  onClick: () => r(a, e),
                  className: "shrink-0 text-red-500 hover:bg-red-100 hover:text-red-600",
                  children: /* @__PURE__ */ t(G, { className: "h-4 w-4" })
                }
              )
            ] }),
            d !== null && d < 1 && /* @__PURE__ */ t("div", { className: "h-1.5 w-full overflow-hidden rounded-full bg-gray-200", children: /* @__PURE__ */ t(
              "div",
              {
                className: "bg-primary h-full transition-all",
                style: { width: `${Math.round(d * 100)}%` }
              }
            ) })
          ]
        },
        N(s)
      );
    }) }),
    /* @__PURE__ */ t(Q, { errors: e.state.meta.errors })
  ] });
}
function ee({
  fileId: e,
  onClick: n,
  variant: o = "outline",
  className: r,
  ...s
}) {
  const [a, i] = h(!1);
  return e ? /* @__PURE__ */ t(
    F,
    {
      variant: o,
      className: r,
      ...s,
      loading: a,
      onClick: async (c) => {
        n?.(c), i(!0);
        try {
          const { signedUrl: d } = await v.request(
            "GET /files/{id}/access",
            { id: e, purpose: "view" }
          );
          window.open(d, "_blank");
        } catch {
          k.error("فشل عرض الملف");
        } finally {
          i(!1);
        }
      }
    }
  ) : /* @__PURE__ */ t("span", { className: "text-muted-foreground text-sm", "aria-disabled": !0, children: "غير متوفر" });
}
function we({
  open: e,
  onOpenChange: n,
  record: o,
  onUploadNewFile: r
}) {
  const { t: s } = j();
  return /* @__PURE__ */ t(q, { open: e, onOpenChange: n, children: /* @__PURE__ */ l(O, { className: "sm:max-w-lg", children: [
    /* @__PURE__ */ t(J, { children: /* @__PURE__ */ l(_, { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ t(b, { className: "h-5 w-5" }),
      s("appointments.detail.attachmentsDialog.title", {
        defaultValue: "البيانات المرفقة"
      })
    ] }) }),
    /* @__PURE__ */ t("div", { className: "py-4 text-start", children: /* @__PURE__ */ l("div", { className: "space-y-4", children: [
      /* @__PURE__ */ l("div", { className: "flex items-center gap-x-2", children: [
        /* @__PURE__ */ t("p", { className: "font-semibold", children: s("appointments.detail.attachmentsDialog.selectedSpecialty", {
          defaultValue: "التخصص المختار"
        }) }),
        /* @__PURE__ */ t(H, { variant: "secondary", className: "p-2", children: o.speciality.name })
      ] }),
      /* @__PURE__ */ l("div", { children: [
        /* @__PURE__ */ t("p", { className: "font-semibold", children: s("appointments.detail.attachmentsDialog.attachedFiles", {
          defaultValue: "الملفات المرفقة"
        }) }),
        /* @__PURE__ */ t("div", { className: "mt-2 space-y-2 rounded-lg border px-4 py-6", children: o.files.map((a) => /* @__PURE__ */ t(te, { file: a }, a.id)) })
      ] }),
      r && /* @__PURE__ */ l(
        y,
        {
          variant: "outline",
          className: "w-full gap-2",
          onClick: r,
          children: [
            s("appointments.detail.attachmentsDialog.uploadNewFile", {
              defaultValue: "تحميل ملف جديد"
            }),
            /* @__PURE__ */ t(V, { className: "h-4 w-4" })
          ]
        }
      )
    ] }) }),
    /* @__PURE__ */ t(K, { className: "gap-2", children: /* @__PURE__ */ t(
      y,
      {
        type: "button",
        variant: "outline",
        onClick: () => n(!1),
        children: s("appointments.detail.attachmentsDialog.close", {
          defaultValue: "إغلاق"
        })
      }
    ) })
  ] }) });
}
function te({
  file: e
}) {
  const { t: n } = j();
  return /* @__PURE__ */ l("div", { className: "flex items-center justify-between", children: [
    /* @__PURE__ */ l("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ t(b, { className: "h-4 w-4 text-gray-500" }),
      /* @__PURE__ */ t("span", { className: "text-sm", children: e.file.name })
    ] }),
    /* @__PURE__ */ t(
      ee,
      {
        fileId: e.fileId,
        variant: "outline",
        size: "sm",
        icon: /* @__PURE__ */ t(A, { className: "h-4 w-4" }),
        children: n("appointments.detail.attachmentsDialog.viewFile", {
          defaultValue: "عرض"
        })
      }
    )
  ] });
}
async function ae(e, n, o) {
  const r = await v.request(e, n);
  if (!(r instanceof Blob))
    throw new Error("Expected a Blob response for file download");
  const s = URL.createObjectURL(r), a = document.createElement("a");
  a.href = s, a.download = o, document.body.appendChild(a), a.click(), document.body.removeChild(a), URL.revokeObjectURL(s);
}
function Ne({
  fileId: e,
  onClick: n,
  variant: o = "outline",
  className: r,
  ...s
}) {
  const [a, i] = h(!1);
  return e ? /* @__PURE__ */ t(
    F,
    {
      variant: o,
      className: r,
      ...s,
      loading: a,
      onClick: async (c) => {
        n?.(c), i(!0);
        try {
          const { signedUrl: d } = await v.request(
            "GET /files/{id}/access",
            { id: e, purpose: "download" }
          );
          window.open(d, "_blank");
        } catch {
          k.error("فشل تحميل الملف");
        } finally {
          i(!1);
        }
      }
    }
  ) : /* @__PURE__ */ t("span", { className: "text-muted-foreground text-sm", "aria-disabled": !0, children: "غير متوفر" });
}
function be({
  endpoint: e,
  input: n,
  filename: o,
  label: r,
  onClick: s,
  variant: a = "outline",
  className: i = "text-foreground",
  ...c
}) {
  const [d, u] = h(!1);
  return /* @__PURE__ */ t(
    F,
    {
      variant: a,
      className: i,
      ...c,
      loading: d,
      onClick: async (m) => {
        s?.(m), u(!0);
        try {
          await ae(e, n, o);
        } catch {
          k.error("فشل تحميل الملف");
        } finally {
          u(!1);
        }
      },
      children: r
    }
  );
}
const Fe = W.instanceof(File).nullable().refine((e) => e instanceof File, {
  message: "هذا الحقل مطلوب. يرجى إرفاق المستند المطلوب"
}).refine(
  (e) => !e || !D(e.type) || e.size <= C(e.type),
  {
    message: "حجم الملف يتجاوز الحد المسموح (١٠ ميجابايت، ٢ جيجابايت لملفات ZIP)"
  }
);
function ne(e, n) {
  return {
    "file-invalid-type": "نوع الملف غير مدعوم",
    "file-too-large": "حجم الملف كبير جداً. الحد الأقصى ١٠ ميجابايت (٢ جيجابايت لملفات ZIP)",
    "file-too-small": "حجم الملف صغير جداً",
    "too-many-files": "عدد كبير من الملفات. يُسمح بملف واحد فقط"
  }[e] || n;
}
function se(e) {
  if (!D(e.type)) return null;
  const n = C(e.type);
  return e.size > n ? {
    code: "file-too-large",
    message: `file exceeds ${n} bytes`
  } : null;
}
function ke({
  label: e,
  name: n,
  value: o,
  onChange: r,
  accept: s = {
    "application/pdf": [".pdf"],
    "image/jpeg": [".jpg", ".jpeg"],
    "image/png": [".png"],
    "application/zip": [".zip"],
    "application/x-zip-compressed": [".zip"]
  },
  maxSizeBytes: a = 2 * 1024 ** 3,
  helperText: i = "PDF, JPG / JPEG, PNG, ZIP",
  suffix: c,
  canDelete: d = !0
}) {
  const [u, m] = h([]), f = o ?? null, $ = w(
    (p, x) => {
      if (m(x), p && p.length > 0) {
        const g = p[0];
        r?.(g);
      }
    },
    [r]
  ), { getRootProps: E, getInputProps: I, isDragActive: R } = Y({
    onDrop: $,
    accept: s,
    multiple: !1,
    maxSize: a,
    validator: se
  }), T = () => {
    m([]), r?.(null);
  };
  return /* @__PURE__ */ l("div", { className: "space-y-4", children: [
    /* @__PURE__ */ l(U, { className: "text-sm font-medium", children: [
      e,
      /* @__PURE__ */ t(B, { size: 16 })
    ] }),
    /* @__PURE__ */ t("div", { className: "relative", children: /* @__PURE__ */ l(
      "div",
      {
        ...E(),
        className: X(
          "border-input flex h-12 w-full cursor-pointer items-center justify-between rounded-md border border-dashed px-3 py-2 text-sm transition-colors",
          "hover:bg-accent hover:text-accent-foreground",
          R && "border-primary bg-primary/5",
          u.length > 0 && "border-destructive",
          f && "border-none bg-gray-50"
        ),
        children: [
          /* @__PURE__ */ t("input", { ...I(), name: n }),
          f ? /* @__PURE__ */ l("div", { className: "flex w-full items-center gap-2", children: [
            P(f.type) ? /* @__PURE__ */ t(z, { size: 16 }) : /* @__PURE__ */ t(b, { size: 16 }),
            /* @__PURE__ */ t("span", { className: "truncate text-right", children: f.name }),
            d && /* @__PURE__ */ t(
              y,
              {
                type: "button",
                variant: "ghost",
                size: "sm",
                onClick: (p) => {
                  p.stopPropagation(), T();
                },
                className: "text-destructive hover:text-destructive/90 mr-auto h-6 shrink-0 cursor-pointer px-2",
                children: /* @__PURE__ */ t(M, { size: 14 })
              }
            ),
            c
          ] }) : /* @__PURE__ */ l("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ t(Z, { className: "size-4 shrink-0" }),
            /* @__PURE__ */ l("span", { className: "text-right", children: [
              i,
              " - ادرج الملف"
            ] })
          ] })
        ]
      }
    ) }),
    u.length > 0 && /* @__PURE__ */ t("div", { className: "text-destructive text-xs", children: u.map((p, x) => /* @__PURE__ */ t("div", { children: p.errors.map((g) => ne(g.code, g.message)).join(", ") }, `${p.file.name}-${x}`)) })
  ] });
}
async function ze(e, n = {}) {
  const { fileId: o, sessionUri: r, chunkSize: s } = await v.request(
    "POST /signed-url",
    {
      name: e.name,
      type: e.type,
      size: e.size
    }
  ), a = e.size;
  let i = 0;
  for (; i < a; ) {
    const c = Math.min(i + s, a), d = e.slice(i, c), u = c === a, m = await ie({
      sessionUri: r,
      chunk: d,
      start: i,
      end: c,
      total: a,
      signal: n.signal
    });
    if (u) {
      if (!m.ok)
        throw new Error(`Final chunk failed: ${m.status}`);
      i = a, n.onProgress?.(a, a);
      break;
    }
    if (m.status !== 308)
      throw new Error(`Unexpected chunk response: ${m.status}`);
    i = re(m.headers.get("Range")), n.onProgress?.(i, a);
  }
  return o;
}
async function ie(e) {
  const n = `bytes ${e.start}-${e.end - 1}/${e.total}`;
  return fetch(e.sessionUri, {
    method: "PUT",
    headers: { "Content-Range": n },
    body: e.chunk,
    signal: e.signal
  });
}
function re(e) {
  const n = e?.match(/bytes=0-(\d+)/);
  if (!n)
    throw new Error(
      "GCS resumable PUT returned 308 without a usable Range header — cannot determine confirmed offset"
    );
  return Number(n[1]) + 1;
}
export {
  xe as AttachFilesField,
  we as AttachmentsDialog,
  be as DownloadButton,
  Ne as DownloadFile,
  ke as UploadField,
  ee as ViewFile,
  ae as downloadFile,
  Fe as fileField,
  N as fileKey,
  ze as uploadFile,
  ve as useUploadProgress
};
//# sourceMappingURL=index.js.map
